module.exports = __webpack_public_path__ + "img/shipo-icon-box.23c356a1.svg";